<!--TEMPLATE-->
<template>
  <dean-section-title-item
      v-if="!isRemoved"
      :icon='removeIcon'
      slot="title-items"
      :content="true"
      :large="false"
      @click.native="removeClick">
    {{textRemove}}
  </dean-section-title-item>
  <dean-section-title-item
      v-else
      :icon='restoreIcon'
      slot="title-items"
      :content="true"
      :large="false"
      @click.native="restoreClick">
    {{textRestore}}
  </dean-section-title-item>
</template>
<!--SCRIPT-->
<script lang="ts">
  // VUE
  import {Component, Vue, Prop, Emit} from 'vue-property-decorator';

  import {
    deanSectionTitleItem,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitleItem,
    },
  })

  export default class deanSectionTitleRemoveRestore extends Vue {
    @Prop({default: false}) isRemoved!: boolean;
    @Prop() textRemove!: string;
    @Prop() textRestore!: string;
    @Prop() removeIcon!: object;
    @Prop() restoreIcon!: object;

    @Emit('remove')
    public removeClick() {}

    @Emit('restore')
    public restoreClick() {}
  }
</script>
<!--STYLE-->
<style lang="scss" scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
